import { Icons } from 'plume-ui';
import { MenuItems } from 'plume-ui/dist/components/Menu/Menu';
import React from 'react';

import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { Routes } from '../config';
import { activePartnerAtom } from '../state';
import { Permission } from '../userPermissionConfig';
import { useGetCurrentRoute } from '../utils/hooks/useGetCurrentRoute';
import { useRedirectToRoute } from '../utils/hooks/useRedirectToRoute';
import { useFeaturePermission } from './useFeaturePermission';

const useMenu = () => {
  const getCurrentRoute = useGetCurrentRoute();
  const redirectToRoute = useRedirectToRoute();
  const { t } = useTranslation();
  const { hasPermission } = useFeaturePermission();
  const selectedPartnerId = useRecoilValue(activePartnerAtom);

  const currentRoute = getCurrentRoute();

  const getPartnerId = () => ({
    partnerId: selectedPartnerId?.id,
  });

  const commonMenuItems: MenuItems = [
    {
      name: t('menu.healthSummary'),
      iconLeft: <Icons.HealthIcon width={24} />,
      iconRight: <Icons.ArrowRightIcon />,
      iconLeftSelected: <Icons.MonitorFillIcon width={24} />,
      onItemClick: () => {
        redirectToRoute(Routes.HealthSummary, getPartnerId());
      },
      isSelected: [Routes.Index, Routes.HealthSummary].includes(currentRoute),
    },
    {
      name: t('menu.monitors'),
      iconLeft: <Icons.EyeIcon width={24} />,
      iconRight: <Icons.ArrowRightIcon />,
      iconLeftSelected: <Icons.ContentAccessInsiteFillIcon width={24} />,
      onItemClick: () => {
        redirectToRoute(Routes.Monitors, getPartnerId());
      },
      isSelected: [
        Routes.Monitors,
        Routes.MonitorsTab,
        Routes.MonitorAdd,
        Routes.OutreachEdit,
        Routes.MonitorDetails,
        Routes.AutonomousMonitorDetails,
        Routes.MonitorEdit,
      ].includes(currentRoute),
    },
    {
      name: t('menu.configuration'),
      iconLeft: <Icons.SettingsIcon width={24} />,
      iconRight: <Icons.ArrowRightIcon />,
      iconLeftSelected: <Icons.SettingsFillIcon width={24} />,
      onItemClick: () => {
        redirectToRoute(Routes.Configuration, getPartnerId());
      },
      isSelected: currentRoute === Routes.Configuration,
      isDisabled: !hasPermission(Permission.ViewConfiguration),
    },
  ];

  const grouped = [
    {
      items: commonMenuItems,
    },
  ];

  return () => grouped;
};

export default useMenu;
